.row { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 10px 24px; }
.scroll { min-width: 0; }
.filter { display: flex; width: max-content; border: var(--border-control); background: var(--paper); }
.option { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 14px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--ink); background: var(--paper); white-space: nowrap; }
.option[aria-current='page'] { background: var(--ink); color: var(--paper); }
.swatch { flex: none; width: 8px; height: 8px; border: 1px solid var(--ink); }
.option[aria-current='page'] .swatch { border-color: var(--paper); }
.note { display: inline-flex; align-items: center; gap: 6px; margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); }
.note svg { flex: none; }
.chip { align-self: flex-start; display: inline-flex; align-items: center; gap: 6px; margin: 0; padding: 5px 8px; background: var(--paper-2); border: var(--border-hair); font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--ink); }

@media (max-width: 639px) {
  .row { flex-direction: column; align-items: stretch; gap: 6px; }
  /* The filter scrolls sideways inside its own box; the page never does. */
  .scroll { overflow-x: auto; }
  .filter { height: 44px; }
  .option { min-width: 48px; padding: 0 12px; }
  .note { align-items: flex-start; letter-spacing: 0.6px; line-height: 1.5; }
}
